import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { FormattedDateFormat, formatAbsoluteDate, formatRelativeDate } from '../../../helpers/formatDate';
import { Cell } from './Cell';
const Relative = styled.div `
  position: relative;
  opacity: 1;
  white-space: nowrap;
  color: ${({ theme }) => theme.secondary.blendToBackground(800)};
  transition: opacity 0.2s;
`;
export const Absolute = styled.div `
  position: absolute;
  display: inline-block;
  color: ${({ theme }) => theme.secondary.background};
  top: 0;
  right: 0;
  white-space: nowrap;
  opacity: 0;
  z-index: 1;
  width: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.secondary.blendToBackground(50)};
  transition: opacity 0.2s;

  ${({ theme }) => theme.id !== 'default' &&
    css `
      background-color: ${theme.secondary.blendToBackground(25)};
    `}

  &:before {
    content: '';
    position: absolute;
    right: 100%;
    top: 0;
    bottom: 0;
    width: 32px;
    background-image: linear-gradient(
      90deg,
      ${({ theme }) => theme.secondary.blendToBackground(50, 0)} 0%,
      ${({ theme }) => theme.secondary.blendToBackground(50, 1000)} 100%
    );

    ${({ theme }) => theme.id !== 'default' &&
    css `
        background-image: linear-gradient(
          90deg,
          ${theme.secondary.blendToBackground(25, 0)} 0%,
          ${theme.secondary.blendToBackground(25, 1000)} 100%
        );
      `}
  }
`;
const DisplayCell = styled(Cell) `
  font-size: 12px;
  overflow: visible;

  ${({ preventHover }) => !preventHover &&
    css `
      &:hover {
        ${Absolute} {
          opacity: 1;
          width: auto;
          overflow: visible;
          padding: 8px 24px 8px 24px;
        }

        ${Relative} {
          opacity: 0;
        }
      }
    `}
`;
const isValidDate = (value) => {
    const d = value instanceof Date ? value : new Date(value);
    return d instanceof Date && !isNaN(d.getTime());
};
export const TimeCell = ({ value, preventHover = false }) => {
    const absoluteTime = useMemo(() => {
        return formatAbsoluteDate(value);
    }, [value]);
    const relativeTime = useMemo(() => {
        return formatRelativeDate(value, { format: FormattedDateFormat.TimePassed });
    }, [value]);
    return (React.createElement(DisplayCell, { preventHover: preventHover }, !isValidDate(value) ? ('-') : (React.createElement(React.Fragment, null,
        React.createElement(Relative, null, relativeTime),
        React.createElement(Absolute, null, absoluteTime)))));
};
//# sourceMappingURL=TimeCell.js.map